<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />

    <div class="main-panel" :data="sidebarBackground">
     <div>
        <dashboard-navbar module="checklist"></dashboard-navbar>
     </div>
      <router-view name="header"></router-view>

      <zoom-center-transition :duration="200" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
  
  <script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
//import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "@/pagesRms/support/SupportNavbar.vue";
import ContentFooter from "@/pages/Layout/ContentFooter.vue";
import SidebarFixedToggleButton from "@/pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
  },

  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
      isMasterAdmin: false,
    };
  },
  created() {
    this.getUserMaster();
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    isUserFormCreator() {
      return this.$store.getters.isChecklistFormCreator;
    },
    isUserFormFiller() {
      return this.$store.getters.isChecklistFormFiller;
    },
    isUserPendenciesViewer() {
      return this.$store.getters.isChecklistPendenciesView;
    },
    isUserViewer() {
      return this.$store.getters.hasAccessUser;
    },
    isProfileViewer() {
      return this.$store.getters.hasAccessProfile;
    },
    isCompanyViewer() {
      return this.$store.getters.hasAccessCompany;
    },
    isAccessVehicles() {
      return this.$store.getters.accessVehicles;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        //initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then((response) => {
          this.isMasterAdmin = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemSchedules) {
      if (this.$refs.sidebarItemSchedules.collapsed) {
        this.$refs.sidebarItemSchedules.collapseMenu();
      }
    }
  },
};
</script>
  
  <style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
  